var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 10,
    viewBox: "0 0 86 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43,
    cy: 5,
    rx: 43,
    ry: 5,
    fill: "#CBC7E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationShadow);
export default __webpack_public_path__ + "static/media/location_shadow.3fa33f5d7ca6f3cc4454bbb827d183fc.svg";
export { ForwardRef as ReactComponent };